import Styles from './Setting.module.scss'
import { useState } from 'react';
import { caseList1,caseList5,caseList2,caseList3,caseList4 } from '../utils/products'
import { useNavigate, useLocation } from 'react-router-dom'
import { getLangName as t } from '../utils/index'
function Settings() {
  const navigate = useNavigate();
  const [index, setIndex] = useState(0)
  const handleDetail = (item) => {
    navigate('/settingsDetail/' + item);
  }

  return <>
    <div className={Styles.settings}>
      <div className={Styles.settings_tab}>
        <div className={Styles.settings_tab_item}>
          {t('ClassicCases')}
        </div>
      </div>
      <div className={Styles.settings_box}>
        <div className={Styles.settings_box_item0} onClick={() => handleDetail(1)}>
          <img src={caseList1[0].img} />
          <div className={Styles.settings_box_item_title}>{caseList1[0].title}</div>
        </div>
        <div className={Styles.settings_box_item1}>
          <div className={Styles.settings_box_item2} style={{ marginBottom: '20px' }}  onClick={() => handleDetail(2)}>
            <img src={caseList2[1].img} />
            <div className={Styles.settings_box_item_title}>{caseList2[0].title}</div>
          </div>
          <div className={Styles.settings_box_item2} onClick={() => handleDetail(3)}>
            <img src={caseList3[0].img} />
            <div className={Styles.settings_box_item_title}>{caseList3[0].title}</div>
          </div>
        </div>
        <div className={Styles.settings_box_item2} style={{ marginRight: '25px' }} onClick={() => handleDetail(4)}>
          <img src={caseList4[0].img} />
          <div className={Styles.settings_box_item_title}>{caseList4[0].title}</div>
        </div>
        <div className={Styles.settings_box_item2}  onClick={() => handleDetail(5)}>
          <img src={caseList5[0].img} />
          <div className={Styles.settings_box_item_title}>{caseList5[0].title}</div>
        </div>
      </div>
    </div>
  </>
}

export default Settings;